import { initialEndDate, initialStartDate } from '../../utils'
import { type Time, buildTimeSlots } from '@user/components/Formik/TimePicker'

export type FiltersFormModel = {
  startDate: Date | null
  endDate: Date | null
  startTime: Time
  endTime: Time
  duration: number | ''
  techRegionId: string
  techId: string
}

export type Option = {
  id: string
  label: string
}

export type HideableOption = Option & {
  hidden: boolean
}

export const timeSlots = buildTimeSlots(15, 6, 21)

export const filtersInitValues: FiltersFormModel = {
  startDate: initialStartDate,
  endDate: initialEndDate,
  startTime: null,
  endTime: null,
  duration: '',
  techRegionId: '',
  techId: '',
}

export function translateDateError(error: string | null) {
  if (error === null) return

  switch (error) {
    case 'disablePast':
      return 'Must not be in the past'
    case 'invalidRange':
      return 'Invalid Range'
    case 'invalidDate':
    default:
      return 'Invalid Date'
  }
}
